module.exports = __webpack_public_path__ + "img/qu_hr.3f44758.jpg";